'use strict';

// eslint-disable-next-line max-lines-per-function
angular.module('webAgro1App').factory('DrawPolygonsObjectService', function(
  MapaService
) {
  const getCoordinates = function(drawPolygon) {
    const coordenadas = drawPolygon.coordenadas || [];

    if (!coordenadas.length) {
      const polygons = drawPolygon.polygons.map((coord) => {
        let layer = coord.layer;
        if (drawPolygon.tipo === 'uso_maquina' || drawPolygon.tipo === 'plantio_operador') {
          layer = 'polyline';
        }
        return { ...coord, layer: layer };
      });

      return polygons;
    }

    return coordenadas.map((coordenada, index) => {
      let polygons = [];
      if (coordenada.layer === 'polyline') {
        polygons = drawPolygon.polygons.flatMap((polygon) => polygon.pontos);
      } else {
        polygons = drawPolygon.polygons[index].pontos;
      }

      return ({
        area: coordenada.area || drawPolygon.areaTotal,
        layer: coordenada.layer,
        pontos: polygons
      });
    });
  };

  return {
    // eslint-disable-next-line complexity
    convertToSend: function(drawPolygon) {
      return {
        area: drawPolygon.areaTotal,
        atividade_id: (drawPolygon.atividade || {}).id || null,
        cd_insumo: ((drawPolygon.cultivar || {}).id || [])[1] || null,
        descricao: drawPolygon.descricao,
        id: drawPolygon.id || null,
        propriedade_id: drawPolygon.propriedade.id,
        safra_id: (drawPolygon.safra || {}).id || null,
        tp_insumo: ((drawPolygon.cultivar || {}).id || [])[0] || null,
        relacao_campo_id: (drawPolygon.relacaoCampo || {}).id || null,
        tipo: drawPolygon.tipo,
        coordenadas: getCoordinates(drawPolygon),
        operador_id: drawPolygon.operador,
        empreendimento_id: drawPolygon.empreendimento,
        largura_plantio: drawPolygon.larguraPlantio,
        maquina_id: drawPolygon.maquina,
        cor: drawPolygon.cor
      };
    },

    createPolygons: function(coordenadas) {
      return (coordenadas || []).map(function(objetoCoordenada) {
        const polygon = MapaService.getGoogleMapsPolygon(objetoCoordenada.pontos);
        polygon.area = objetoCoordenada.area;
        polygon.setOptions(DRAW_POLYGON_OPTIONS);
        return polygon;
      });
    },

    createLeafletPolygons: function(coordenadas) {
      return (coordenadas || []).map(function(objetoCoordenada) {
        const polygon = MapaService.getLeafletPolygon(objetoCoordenada.pontos);
        polygon.area = objetoCoordenada.area;
        return polygon;
      });
    },

    createLayers: function(coordenadas, faixasVelocidade) {
      let objects = [];
      (coordenadas || []).forEach(function(objetoCoordenada) {
        objetoCoordenada.faixas = faixasVelocidade;
        if (objetoCoordenada.layer === google.maps.drawing.OverlayType.POLYLINE) {
          objects = objects.concat(MapaService.getGoogleMapsPolylineWithObject(objetoCoordenada));
        } else {
          const polygon = MapaService.getGoogleMapsPolygon(objetoCoordenada.pontos);
          polygon.area = objetoCoordenada.area;
          polygon.setOptions(DRAW_POLYGON_OPTIONS);
          objects.push(polygon);
        }
      });

      return objects;
    },

    createLayersLeaflet: function(coordenadas, faixasVelocidade, drawPolygon) {
      let objects = [];
      (coordenadas || []).forEach(function(objetoCoordenada) {
        objetoCoordenada.faixas = faixasVelocidade;
        if (objetoCoordenada.layer === google.maps.drawing.OverlayType.POLYLINE) {
          objects = objects.concat(MapaService.getLeafletPolylineWithObject(objetoCoordenada));
        } else {
          const options = {
            ...DRAW_POLYGON_OPTIONS_LEAFLET,
            color: drawPolygon.cor || DRAW_POLYGON_OPTIONS_LEAFLET.color
          };
          const polygon = MapaService.getLeafletPolygon(objetoCoordenada.pontos, options);
          polygon.area = objetoCoordenada.area;
          polygon.layer = objetoCoordenada.layer;
          objects.push(polygon);
        }
      });

      return objects;
    },

    createLayersForEdition: function(coordenadas) {
      return (coordenadas || []).map(function(objetoCoordenada) {
        const isPolyline = objetoCoordenada.layer === google.maps.drawing.OverlayType.POLYLINE;
        // eslint-disable-next-line max-len
        const polygon = isPolyline ? MapaService.getGoogleMapsPolyline(objetoCoordenada.pontos) : MapaService.getGoogleMapsPolygon(objetoCoordenada.pontos);
        polygon.area = objetoCoordenada.area;
        polygon.setOptions(DRAW_POLYGON_OPTIONS);
        return polygon;
      });
    },

    convertToObjectLeaflet(drawPolygon) {
      return this.convertToObject(drawPolygon, true);
    },

    convertToObject: function(drawPolygon, leaflet = false) {
      if (!drawPolygon || !drawPolygon.id) {
        return {};
      }

      const params = [drawPolygon.coordenadas, drawPolygon.faixas_velocidade, drawPolygon];
      // eslint-disable-next-line prefer-spread
      const polygons = leaflet ? this.createLayersLeaflet.apply(this, params) : this.createLayers.apply(this, params);
      return {
        areaTotal: drawPolygon.area,
        atividade: drawPolygon.atividade,
        coordenadas: drawPolygon.coordenadas,
        cultivar: drawPolygon.insumo,
        descricao: drawPolygon.descricao,
        gleba: drawPolygon.gleba,
        id: drawPolygon.id,
        polygons: polygons,
        propriedade: drawPolygon.propriedade,
        safra: drawPolygon.safra,
        usuario: drawPolygon.usuario,
        maquina_id: drawPolygon.maquina_id,
        relacaoCampo: drawPolygon.relacao_campo,
        tipo: drawPolygon.tipo,
        operador: drawPolygon.operador,
        empreendimento: drawPolygon.empreendimento,
        larguraPlantio: +drawPolygon.largura_plantio,
        velocidadeMedia: +drawPolygon.velocidade_media,
        distancia: +drawPolygon.distancia / 1000.0,
        carregarAutomaticamente: drawPolygon.carregar_automaticamente,
        cor: drawPolygon.cor
      };
    }
  };
});
